/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactDto
 */
export interface ContactDto {
    /**
     * 
     * @type {number}
     * @memberof ContactDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDto
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDto
     */
    phoneNumber: string;
}

export function ContactDtoFromJSON(json: any): ContactDto {
    return ContactDtoFromJSONTyped(json, false);
}

export function ContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'fullName': json['fullName'],
        'emailAddress': json['emailAddress'],
        'phoneNumber': json['phoneNumber'],
    };
}

export function ContactDtoToJSON(value?: ContactDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fullName': value.fullName,
        'emailAddress': value.emailAddress,
        'phoneNumber': value.phoneNumber,
    };
}


